import { sendContactSucces, sendContactFailure, SEND_CONTACT_REQUEST } from './actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { sendContact } from './contactService';

function* sendContactSaga(action) {
  try {
    const data = yield call(sendContact, action.payload);
    yield put(sendContactSucces(data.message));
  } catch (error) {
    yield put(sendContactFailure(error.message));
  }
}

export default function* watchContactSaga() {
  yield takeLatest(SEND_CONTACT_REQUEST, sendContactSaga);
}
